import { State } from "reducers";

export default (state: State): string | null => state.session.refreshToken;
